import { Component, OnInit,Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { MenuController } from '@ionic/angular';
// import { PosPage } from '../../pages/pos/pos.page';

@Component({
  selector: 'app-pos-category',
  templateUrl: './pos-category.component.html',
  styleUrls: ['./pos-category.component.scss'],
})
export class PosCategoryComponent implements OnInit {
  @Input() categoty_list;
  // public pos:PosPage,
  constructor(public DBservice: DataService,public menuCtrl:MenuController) { }

  ngOnInit() {}

  get_items(item,index){
    // this.pos.get_items(item,index);
  }

}
